<app-alert></app-alert>
<div *ngIf="!invoiceLoaded" class="loading-overlay d-flex">
  <div class="d-flex flex-column m-auto">
    <h2>Loading Invoice</h2>
    <fa-icon [icon]="faCircleNotch" size="2xl" spin="true" class="mx-auto mt-2"></fa-icon>
  </div>
</div>
<div [class.d-none]="!invoiceLoaded">
  <div class="container py-2">
    <div class="container-fluid toolbar border-bottom">
      <button type="button" class="btn btn-sm btn-primary d-print-none" (click)="print();">
        <fa-icon class="button-icon-left" [icon]="faPrint"></fa-icon>
        <span>Print Invoice</span>
      </button>
      <button type="button" class="btn btn-sm btn-primary darkmode-button" (click)="localDarkModeController.toggleDarkMode()">Toggle {{localDarkModeController.isDarkModeEnabled() ? 'Light Mode' : 'Dark Mode'}} &nbsp; <fa-icon [icon]="(localDarkModeController.isDarkModeEnabled()) ? faSun : faMoon"></fa-icon></button>
    </div>
    <div class="row">
      <div class="col">
        <h2 *ngIf="project" style="font-weight: 600;">{{project.name}}</h2>
        <h2 *ngIf="invoice">Invoice #{{invoice.number}}</h2>
      </div>
      <div class="col text-md-end d-none d-sm-block">
        <img *ngIf="logoUrl" [src]="logoUrl" width="40%" class="logo" alt="Organization Logo">
      </div>
    </div>
    <!-- Client, Site, and Business Attributes -->
    <div class="row mt-2">
      <div class="col pe-3">
        <div class="row">
          <div class="col-md-8">
            <div *ngIf="client">
              <h5>{{client.name}} (Billing)</h5>
              <p class="mb-0">{{client.address.street}}</p>
              <p class="mb-0">{{client.address.city}}, {{client.address.state}} {{client.address.postalCode}}</p>
            </div>
            <div *ngIf="primaryContact" class="d-block text-break">
              <a href="mailto:{{primaryContact.email}}">{{primaryContact.email}}</a>
              <br>
              <a href="tel:{{primaryContact.phone}}">{{primaryContact.phone}}</a><span *ngIf="primaryContact.phoneExtension">x{{primaryContact.phoneExtension}}</span>
            </div>
          </div>
          <div class="col-md-4 mt-md-0 mt-2">
            <div *ngIf="site">
              <h5>{{site.name}} (Site)</h5>
              <p class="mb-0">{{site.address.street}}</p>
              <p class="mb-0">{{site.address.city}}, {{site.address.state}} {{site.address.postalCode}}</p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="businessAttributes" class="col text-md-end">
        <div class="row">
          <div class="col">
            <div>
              <h5>{{businessAttributes.name}}</h5>
              <div *ngIf="businessAttributes.displayAddress">
                <p class="mb-0">{{businessAttributes.address.street}}</p>
                <p class="mb-0">{{businessAttributes.address.city}}, {{businessAttributes.address.state}} {{businessAttributes.address.postalCode}}</p>
              </div>
              <div class="d-block text-break">
                <a class="pe-0 ps-0" href="mailto:{{businessAttributes.email}}">{{businessAttributes.email}}</a>
                <br>
                <a class="pe-0 ps-0" href="tel:{{businessAttributes.phone}}">{{businessAttributes.phone}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4 col-lg-6 mt-1">
        <p *ngIf="invoice" class="mb-0"><strong>Issue Date:</strong> {{invoice.issueDate | formatDateTime: true}}</p>
        <p *ngIf="invoice" class="mb-0"><strong>Due Date:</strong> {{invoice.dueDate | formatDateTime: true}}</p>
      </div>
      <div class="col-xs-4 col-lg-6 text-md-end mt-1">
        <!-- Make Payment Button -->
        <div *ngIf="invoice && invoice.status != 'PAID' && invoice.status != 'CANCELED' && hasEnabledPaymentOption() && invoice.status != 'OVERPAID'" class="d-print-none">
          <button type="button" class="btn btn-lg btn-primary" (click)="openModal(PAYMENT_CATEGORY_MODAL);">
            <fa-icon class="button-icon-left" [icon]="faCreditCard"></fa-icon>
            <span>Make Payment</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Features -->
    <div class="row mt-1">
      <h2 class="p-0 border-bottom">Features</h2>
      <div class="col mt-2">
        <!-- <p *ngIf="acceptedProposal && proposalPricing && acceptedProposal.agreementType == 'SINGLE'" class="text-nowrap ms-auto my-auto text-end fw-bold">{{proposalPricing.total | currency}}</p> -->
        <ng-container *ngFor="let feature of features; index as i;">
          <div class="card" [class.mt-2]="i > 0" *ngIf="!feature.isHidden && feature.isSelected">
            <div class="card-body">
              <div class="d-flex">
                <div class="d-flex flex-column w-100">
                  <div class="d-flex">
                    <input id="ACCEPT-{{feature.id}}" type="checkbox" class="form-check-input" [checked]="feature.isSelected" disabled>
                    <h5 class="card-title mb-0 ms-2">{{feature.name}}</h5>
                    <p *ngIf="acceptedProposal.agreementType == 'SINGLE' && !feature.costHidden" class="text-nowrap ms-auto my-auto">{{feature.totalPrice | currency}}</p>
                  </div>
                  <h6 *ngIf="feature.description" class="card-subtitle text-muted mt-1">{{feature.description}}</h6>
                  <div *ngIf="acceptedProposal.agreementType == 'MULTI' && !feature.costHidden" class="row mt-1">
                    <ng-container *ngFor="let key of multiOptionKeys; index as i;">
                      <div *ngIf="key === acceptedProposal.selectedMultiOption;" class="col-auto p-0 d-md-flex flex-md-row" [class.ms-2]="i > 0">
                        <strong>{{acceptedProposal.multiOptions[key].acronym}}</strong>
                        <div class="ms-md-1">{{feature.totalPricingMulti[key] | currency}}</div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <ul class="list-group list-group-flush">
                <li *ngFor="let featureItem of feature.featureItems" class="list-group-item list-group-item-action d-flex py-3">
                  <div class="d-flex w-100 justify-content-between" *ngIf="!featureItem.hidden">
                    <div class="h-fit my-auto">
                      <h6 class="mb-0">{{featureItem.name}}</h6>
                      <p *ngIf="!featureItem.quantityHidden" class="mb-0 opacity-75">Quantity: {{featureItem.quantity}}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row mt-2">
      <h2 class="p-0 border-bottom">Payments & Pricing</h2>
      <div class="col-lg-8 mt-2">
        <div class="card w-100">
          <h5 class="card-header">Payments</h5>
          <div class="card-body">
            <ul class="list-group scrollable" style="height: 250px;">
              <li *ngFor="let payment of payments" class="list-group-item list-group-item-action">
                <div class="d-flex">
                  <div class="d-flex flex-column">
                    <div class="d-flex">
                      <strong style="line-height: 21px;">{{payment.category | paymentCategory}} </strong>
                      <div class="d-flex">
                        - <a routerLink="/invoices/{{payment.invoiceId}}/view">Invoice {{payment.invoiceNumber}}</a>
                      </div>
                      <div *ngIf="payment.category == 'ACH'">
                        <div [ngSwitch]="payment.status" class="d-flex ms-2">
                          <div *ngSwitchCase="'APPROVED'" class="badge text-bg-success mb-auto">Approved</div>
                          <div *ngSwitchCase="'SETTLED'" class="badge text-bg-success mb-auto">Settled</div>
                          <div *ngSwitchCase="'CLOSED'" class="badge text-bg-success mb-auto">Closed</div>
                          <div *ngSwitchCase="'RETURNED'" class="badge text-bg-danger mb-auto">Returned</div>
                          <div *ngSwitchCase="'PENDING'" class="badge text-bg-warning mb-auto">Pending</div>
                          <div *ngSwitchCase="'VOIDED'" class="badge text-bg-warning mb-auto">Voided</div>
                          <div *ngSwitchCase="'REJECTED'" class="badge text-bg-danger mb-auto">Rejected</div>
                          <div *ngSwitchCase="'NOTICE OF CHANGE'" class="badge text-bg-danger mb-auto">Needs update account information</div>
                        </div>
                      </div>

                      <div *ngIf="payment.category != 'ACH'">
                        <div [ngSwitch]="payment.status" class="d-flex ms-2">
                          <div *ngSwitchCase="'PENDING'" class="badge text-bg-warning mb-auto">Pending</div>
                          <div *ngSwitchCase="'REJECTED'" class="badge text-bg-danger mb-auto">Rejected</div>
                          <div *ngSwitchCase="'CLOSED'" class="badge text-bg-success mb-auto">Closed</div>
                        </div>
                      </div>
                      <div *ngIf="payment.type == 'CREDIT'" class="badge ms-2" style="background-color: var(--pale-blue-color);">Refund</div>
                    </div>
                    <div *ngIf="payment.transaction" [ngSwitch]="payment.category">
                      <small *ngSwitchCase="'CARD'" class="text-muted">{{payment.transaction.brand}} (&#8226;&#8226;&#8226;&#8226; <span style="font-weight: 600;">{{payment.transaction.lastFour}}</span>)</small>
                      <small *ngSwitchCase="'ACH'" class="text-muted">{{payment.transaction.type}} (<span style="font-weight: 600;">{{payment.transaction.lastFour}}</span>)</small>
                    </div>
                    <small *ngIf="payment.surcharge !== 0" class="text-muted">Fee/Total: {{payment.surcharge | currency}}/{{payment.total | currency}}</small>
                    <small class="text-muted">{{payment.date | formatDateTime: true}}</small>
                  </div>
                  <div class="ms-auto my-auto fs-4 text-nowrap">{{payment.amount | currency}}</div>
                </div>
              </li>
              <li *ngIf="payments.length == 0" class="list-group-item">No Payments</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mt-2">
        <div class="card" style="width: 100%; height: 100%;">
          <h5 class="card-header">Pricing</h5>
          <div class="card-body">
            <div *ngIf="proposalPricing && acceptedProposal && acceptedProposal.agreementType === 'MULTI'">
              <!-- Subtotal -->
              <div class="d-flex">
                <div class="my-auto">
                  <p class="mb-1" style="font-weight: 600;">Proposal subtotal</p>
                </div>
                <p class="ms-auto my-auto mb-0">{{proposalPricing.multiPricing[acceptedProposal.selectedMultiOption]?.subtotal | currency}}</p>
              </div>
              <!-- Discount -->
              <div *ngIf="proposalPricing.discount > 0" class="d-flex">
                <div class="my-auto">
                  <p class="mb-1" style="font-weight: 600;">Proposal discount</p>
                </div>
                <div class="ms-auto my-auto">
                  <p *ngIf="proposalPricing.discountType == 'PERCENT'" class="mb-0">{{proposalPricing.discount}}%</p>
                  <p *ngIf="proposalPricing.discountType == 'DOLLAR'" class="mb-0">{{proposalPricing.discount | currency}}</p>
                </div>
              </div>
              <!-- Tax -->
              <div class="d-flex">
                <div class="my-auto">
                  <p class="mb-1" style="font-weight: 600;">Proposal tax</p>
                </div>
                <p class="ms-auto my-auto mb-0">{{proposalPricing.multiPricing[acceptedProposal.selectedMultiOption]?.tax | currency}}</p>
              </div>
              <!-- Total -->
              <div class="d-flex pt-1 pb-2" style="border-top: 2px solid #212529;">
                <div class="my-auto">
                  <p class="mb-0" style="font-weight: 600;">Proposal total</p>
                </div>
                <p class="ms-auto my-auto mb-0">{{proposalPricing.multiPricing[acceptedProposal.selectedMultiOption]?.total | currency}}</p>
              </div>
            </div>
            <div *ngIf="proposalPricing && acceptedProposal && acceptedProposal.agreementType === 'SINGLE'">
              <!-- Subtotal -->
              <div class="d-flex">
                <div class="my-auto">
                  <p class="mb-1" style="font-weight: 600;">Proposal subtotal</p>
                </div>
                <p class="ms-auto my-auto mb-0">{{proposalPricing?.subtotal | currency}}</p>
              </div>
              <!-- Discount -->
              <div *ngIf="proposalPricing?.discount > 0" class="d-flex">
                <div class="my-auto">
                  <p class="mb-1" style="font-weight: 600;">Proposal discount</p>
                </div>
                <div class="ms-auto my-auto">
                  <p *ngIf="proposalPricing.discountType == 'PERCENT'" class="mb-0">{{proposalPricing?.discount}}%</p>
                  <p *ngIf="proposalPricing.discountType == 'DOLLAR'" class="mb-0">{{proposalPricing?.discount | currency}}</p>
                </div>
              </div>
              <!-- Tax -->
              <div class="d-flex">
                <div class="my-auto">
                  <p class="mb-1" style="font-weight: 600;">Proposal tax</p>
                </div>
                <p class="ms-auto my-auto mb-0">{{proposalPricing.tax | currency}}</p>
              </div>
              <!-- Total -->
              <div class="d-flex pt-1 pb-2" style="border-top: 2px solid #212529;">
                <div class="my-auto">
                  <p class="mb-0" style="font-weight: 600;">Proposal total</p>
                </div>
                <p class="ms-auto my-auto mb-0">{{ proposalPricing.total | currency}}</p>
              </div>
            </div>
            <!-- Invoice Amount -->
            <div *ngIf="invoice" class="d-flex mt-2">
              <p class="mb-0" style="font-weight: 600;">Invoice Amount</p>
              <p class="ms-auto my-auto">{{invoice.amount | currency}}</p>
            </div>
            <!-- Amount Paid -->
            <div *ngIf="invoice" class="d-flex mt-2">
              <p class="mb-0" style="font-weight: 600;">Amount Paid
                <span class="ms-auto" style="cursor: pointer;" [ngbPopover]="paymentPopOver" triggers="click">
                  <fa-icon [icon]="faQuestionCircle"></fa-icon>
                </span>
              </p>
              <p class="ms-auto my-auto">{{invoice.totalPaymentAmount | currency}}</p>
            </div>
            <!-- Amount Credited -->
            <!-- <div *ngIf="totalCreditAmount" class="d-flex mt-2">
              <p class="mb-0" style="font-weight: 600;">Amount Credited</p>
              <p class="ms-auto my-auto">{{totalCreditAmount | currency}}</p>
            </div> -->
          </div>
          <div *ngIf="invoice" [ngSwitch]="invoice.status" class="card-footer">
            <div *ngSwitchCase="'PENDING'" class="d-flex">
              <p class="my-auto fs-4" style="font-weight: 700;">Amount Due</p>
              <p class="ms-auto my-auto fs-4">{{invoice.amountDue | currency}}</p>
              <p *ngIf="invoice.status === 'OVERDUE'" class="my-auto fs-4 text-center text-danger" style="font-weight: 700;">Overdue</p>
            </div>
            <div *ngSwitchCase="'OVERDUE'" class="d-flex">
              <p class="my-auto fs-4 text-danger" style="font-weight: 700;">Amount Overdue</p>
              <p class="ms-auto my-auto fs-4">{{invoice.amountDue | currency}}</p><br>
            </div>
            <p *ngSwitchCase="'PAID'" class="my-auto fs-4 text-center" style="color: var(--green-color); font-weight: 700;">Paid</p>
            <p *ngSwitchCase="'CANCELED'" class="my-auto fs-4 text-center text-danger" style="font-weight: 700;">Canceled</p>
            <p *ngSwitchCase="'OVERPAID'" class="my-auto fs-4 text-center text-danger" style="font-weight: 700;">Overpaid</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <h2 class="p-0 border-bottom">Terms & Conditions</h2>
      <div class="col">
        <div class="invoice-terms" id="INVOICE_TERMS" style="padding-top: 1rem; padding-bottom: 1rem;"></div> <!-- /terms -->
      </div>
    </div>
  </div>
</div>

<!-- Payment Category Modal -->
<ng-template #PAYMENT_CATEGORY_MODAL let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Make Payment</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
  </div>
  <div class="modal-body">
    <div ngbAccordion *ngIf="hasEnabledPaymentOption()" [closeOthers]="true">
      <!-- Tinsel Pay Card -->
      <div ngbAccordionItem *ngIf="tinselPayCardPaymentIsEnabled" [collapsed]="false">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Tinsel Pay (Credit/Debit)</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <app-tinsel-pay-card-payment-form [clientId]="client.id" [invoice]="invoice" [defaultAmount]="invoice.amountDue" (paymentSuccessful)="paymentSuccessful()"></app-tinsel-pay-card-payment-form>
          </div>
        </div>
      </div>
      <!-- Tinsel Pay ACH -->
      <div ngbAccordionItem *ngIf="tinselPayAchPaymentIsEnabled">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Tinsel Pay (ACH)</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <app-tinsel-pay-ach-payment-form [clientId]="client.id" [invoice]="invoice" [defaultAmount]="invoice.amountDue" (paymentSuccessful)="paymentSuccessful()"></app-tinsel-pay-ach-payment-form>
          </div>
        </div>
      </div>
      <!-- Square -->
      <div ngbAccordionItem *ngIf="squarePaymentIsEnabled">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Square (Credit/Debit)</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <app-square-payment-form [organizationId]="invoice.organizationId" [invoiceId]="invoice.id" [defaultAmount]="invoice.amountDue" (paymentSuccessful)="paymentSuccessful()"></app-square-payment-form>
          </div>
        </div>
      </div>
      <!-- Venmo -->
      <div ngbAccordionItem *ngIf="venmoPaymentIsEnabled">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Venmo</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <app-venmo-payment-view
              [venmoCodeExists]="venmoCodeExists"
              [venmoCodeUrl]="venmoCodeUrl"
              [venmoProfileUrl]="venmoProfileUrl">
            </app-venmo-payment-view>
          </div>
        </div>
      </div>
      <!-- Cash -->
      <div ngbAccordionItem *ngIf="cashPaymentIsEnabled">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Cash</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <div [innerHTML]="cashMessage"></div>
          </div>
        </div>
      </div>
      <!-- Check -->
      <div ngbAccordionItem *ngIf="checkPaymentIsEnabled">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Check</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <div [innerHTML]="checkMessage"></div>
          </div>
        </div>
      </div>
    </div>

    <p *ngIf="!hasEnabledPaymentOption();" class="mb-0">There are no payment options enabled. Please contact your representative for support.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-secondary" (click)="modal.dismiss();">Cancel</button>
  </div>
</ng-template>

<ng-template #paymentPopOver>
  <p class="mb-0">Total Sum of All Payments and Credit Notes applied to this invoice.</p>
</ng-template>
